'use strict';
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.HotAreaActionHandler = void 0;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopRequireWildcard(require('react'));
var _gemsShared = require('@tencent/gems-shared');
var LONG_PRESS_TIMEOUT = 1000;
var DOUBLE_CLICK_TIMEOUT = 200;
var INTERSECTION_TIMEOUT = 500;
var _obj;
var HotAreaActionHandler = /*#__PURE__*/ function(_PureComponent) {
    _inherits(HotAreaActionHandler, _PureComponent);
    var _super = _createSuper(HotAreaActionHandler);
    function HotAreaActionHandler(props) {
        _classCallCheck(this, HotAreaActionHandler);
        var _this;
        _this = _super.call(this, props);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'intersectionObserver', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'handlerParams', {
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'handlers', {
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'containerRef', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'longPressTimer', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'preventClick', false);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'doubleClickTimer', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'intersectionTimer', null);
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'execActionHooks', function(actions) {
            actions.forEach(function(action) {
                if (typeof action.action.action === 'function') {
                    return;
                }
                var hooks = action.action.action;
                if (hooks.afterHandlerRender) {
                    var params = (0, _gemsShared.generateHotareaActionParams)(action, _this.props.hotArea, _this.props.instance, _this.props.global, _this.props.meta);
                    try {
                        hooks.afterHandlerRender(params);
                    } catch (e) {
                        console.error('Action "afterHandlerRender" hook throw error: ', e);
                    }
                }
            });
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'initIntersectionObserver', function() {
            _this.intersectionObserver = new window.IntersectionObserver(function(entries) {
                entries.forEach(function(param) {
                    var target = param.target, isIntersecting = param.isIntersecting;
                    var key = parseInt(target.getAttribute('data-key'), 10);
                    _gemsShared.events.emit(_gemsShared.EventEmitTypes.HOT_AREA_INTERSECTING_CHANGE, isIntersecting, key);
                });
            });
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'observeIntersection', function() {
            return _this.intersectionObserver.observe(_this.containerRef);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'unobserveIntersection', function() {
            return _this.intersectionObserver.unobserve(_this.containerRef);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onHotAreaIntersectionChange', function(isIntersecting, key) {
            if (key !== _this.props.hotArea.key) {
                return;
            }
            if (_this.intersectionTimer) {
                clearTimeout(_this.intersectionTimer);
                _this.intersectionTimer = null;
            }
            var callback = isIntersecting ? _this.onHotAreaEnterView : _this.onHotAreaLeaveView;
            _this.intersectionTimer = window.setTimeout(function() {
                callback();
                clearTimeout(_this.intersectionTimer);
                _this.intersectionTimer = null;
            }, INTERSECTION_TIMEOUT);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onHotAreaEnterView', function() {
            if (_this.handlers.onEnterView) {
                _this.handlers.onEnterView(undefined);
            }
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onHotAreaLeaveView', function() {
            if (_this.handlers.onLeaveView) {
                _this.handlers.onLeaveView(undefined);
            }
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onHotAreaPress', (0, _gemsShared.withPersistReactEvent)(function(e) {
            if (!_this.handlers.onLongPress) {
                return;
            }
            _this.longPressTimer = window.setTimeout(function() {
                return _this.handlers.onLongPress(e);
            }, LONG_PRESS_TIMEOUT);
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onHotAreaPressRelease', function() {
            if (_this.longPressTimer) {
                window.clearTimeout(_this.longPressTimer);
            }
            _this.longPressTimer = null;
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onMouseEnter', (0, _gemsShared.withPersistReactEvent)(function() {
            _this.handlers.onMouseEnter();
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onMouseLeave', (0, _gemsShared.withPersistReactEvent)(function() {
            _this.handlers.onMouseLeave();
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onSingleClick', (0, _gemsShared.withPersistReactEvent)(function(e1) {
            _this.doubleClickTimer = window.setTimeout(function() {
                if (!_this.preventClick) {
                    try {
                        _this.handlers.onClick(e1);
                    } catch (e) {
                        console.error('Exec onClick action error:', e);
                    }
                }
            }, DOUBLE_CLICK_TIMEOUT);
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'onDoubleClick', (0, _gemsShared.withPersistReactEvent)(function(e) {
            if (_this.doubleClickTimer) {
                clearTimeout(_this.doubleClickTimer);
                _this.doubleClickTimer = null;
            }
            _this.preventClick = true;
            try {
                _this.handlers.onDoubleClick(e);
            } catch (e2) {
                console.error('Exec onClick action error:', e2);
            }
            setTimeout(function() {
                _this.preventClick = false;
            }, DOUBLE_CLICK_TIMEOUT);
        }));
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'emitHotAreaEvent', function(e, type) {
            var _this$props = _this.props, hotArea = _this$props.hotArea, instance = _this$props.instance, _this$handlerParams = _this.handlerParams, global = _this$handlerParams.global, meta = _this$handlerParams.meta;
            return (0, _gemsShared.emitHotArea)(e, type, hotArea, instance, meta, global);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'withEmitHotAreaEvent', function(type, handler) {
            return function(e) {
                if (e) {
                    e.persist();
                }
                _this.emitHotAreaEvent(e, type);
                if (handler) {
                    return handler(e, _this.handlerParams);
                }
            };
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'updateHandlerParams', function(meta, global) {
            _this.handlerParams.meta = meta;
            _this.handlerParams.global = global;
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'updateHandlersWithParams', function(actions) {
            var _generateHandlers = (0, _gemsShared.generateHandlers)(actions, _this.props.instance, _this.props.hotArea), onInit = _generateHandlers.onInit, onClick = _generateHandlers.onClick, onMouseEnter = _generateHandlers.onMouseEnter, onMouseLeave = _generateHandlers.onMouseLeave, onDoubleClick = _generateHandlers.onDoubleClick, onLongPress = _generateHandlers.onLongPress, onEnterView = _generateHandlers.onEnterView, onLeaveView = _generateHandlers.onLeaveView;
            var withEmitHotAreaEvent = _this.withEmitHotAreaEvent, handlers = _this.handlers;
            handlers.onInit = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.INIT, onInit);
            handlers.onClick = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.CLICK, onClick);
            handlers.onMouseEnter = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.MOUSE_ENTER, onMouseEnter);
            handlers.onMouseLeave = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.MOUSE_LEAVE, onMouseLeave);
            handlers.onDoubleClick = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.DOUBLE_CLICK, onDoubleClick);
            handlers.onLongPress = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.LONG_PRESS, onLongPress);
            handlers.onEnterView = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.ENTER_VIEW, onEnterView);
            handlers.onLeaveView = withEmitHotAreaEvent(_gemsShared.HotAreaEventListenerTypes.LEAVE_VIEW, onLeaveView);
        });
        (0, _defineProperty2.default)(_assertThisInitialized(_this), 'setNode', function(node) {
            _this.containerRef = node;
            (0, _gemsShared.setHotAreaNode)(node);
        });
        _this.handlerParams = {
            global: props.global,
            meta: props.meta
        };
        _this.updateHandlersWithParams(props.hotArea.actions);
        return _this;
    }
    _createClass(HotAreaActionHandler, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!process.env.isMiniprogram) {
                    this.initIntersectionObserver();
                    this.observeIntersection();
                }
                _gemsShared.events.on(_gemsShared.EventEmitTypes.HOT_AREA_INTERSECTING_CHANGE, this.onHotAreaIntersectionChange);
                if (this.handlers.onInit) {
                    this.handlers.onInit(undefined);
                }
                this.execActionHooks(this.props.hotArea.actions);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.global !== this.props.global || nextProps.meta !== this.props.meta) {
                    this.updateHandlerParams(nextProps.meta, nextProps.global);
                }
                if (nextProps.hotArea.actions !== this.props.hotArea.actions) {
                    this.updateHandlersWithParams(nextProps.hotArea.actions);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!process.env.isMiniprogram) {
                    this.unobserveIntersection();
                }
                _gemsShared.events.cancel(_gemsShared.EventEmitTypes.HOT_AREA_INTERSECTING_CHANGE, this.onHotAreaIntersectionChange);
                (0, _gemsShared.deleteHotAreaNode)(this.props.hotArea.kebabCase);
                if (this.longPressTimer) {
                    window.clearTimeout(this.longPressTimer);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, _this$props2$style = _this$props2.style, style = _this$props2$style === void 0 ? {
                } : _this$props2$style;
                var elementType = process.env.isMiniprogram ? 'wx-button' : 'div'; // wx-button 视为 Web Components, 故使用 class, 见 https://reactjs.org/docs/dom-elements.html#classname
                var classKey = process.env.isMiniprogram ? 'class' : 'className';
                return(/*#__PURE__*/ React.createElement(elementType, (_obj = {
                }, _defineProperty(_obj, classKey, '__impage-hot-area-actions-proxy'), _defineProperty(_obj, "id", (0, _gemsShared.getHotAreaId)(this.props.hotArea.key)), _defineProperty(_obj, "ref", this.setNode), _defineProperty(_obj, 'data-key', this.props.hotArea.key), _defineProperty(_obj, "onClick", this.onSingleClick), _defineProperty(_obj, "onDoubleClick", this.onDoubleClick), _defineProperty(_obj, "onMouseEnter", this.onMouseEnter), _defineProperty(_obj, "onMouseLeave", this.onMouseLeave), _defineProperty(_obj, "onTouchStart", this.onHotAreaPress), _defineProperty(_obj, "onTouchEnd", this.onHotAreaPressRelease), _defineProperty(_obj, "onMouseDown", this.onHotAreaPress), _defineProperty(_obj, "onMouseUp", this.onHotAreaPressRelease), _defineProperty(_obj, "style", style), _obj), children));
            }
        }
    ]);
    return HotAreaActionHandler;
}(React.PureComponent);
exports.HotAreaActionHandler = HotAreaActionHandler;
